import { Suspense } from 'react'
import { GMAP_KEY } from 'constants/envs'
import { ProducerMapProps } from './types'
import { energyToIconName } from 'utils/mapping.ts'
import { getAverage } from 'utils/number.ts'
import { AdvancedMarker, AdvancedMarkerAnchorPoint, APIProvider, Map } from '@vis.gl/react-google-maps'
import Marker from 'components/map/marker/Marker.tsx'
import styles from './mapStyles.json'

const ProducerMap = ({ producerLocation, userLocation, producerEnergyType, producerLocations }: ProducerMapProps) => {
  // Constants
  const isProducerProfile = !!producerLocations
  const centerCoord = {
    lat: getAverage(
      isProducerProfile
        ? producerLocations?.map((loc) => loc.lat)
        : userLocation
          ? [producerLocation.lat, userLocation.lat]
          : [producerLocation.lat]
    ),
    lng: getAverage(
      isProducerProfile
        ? producerLocations?.map((loc) => loc.lng)
        : userLocation
          ? [producerLocation.lng, userLocation.lng]
          : [producerLocation.lng]
    )
  }

  return (
    <Suspense fallback={<div className="card" />}>
      <APIProvider apiKey={GMAP_KEY}>
        <Map
          mapId="DEMO_MAP_ID" // Required for AdvancedMarkers (but prohibits custom styling through JSON)
          style={{ width: '100%' }}
          defaultCenter={centerCoord}
          defaultZoom={8}
          gestureHandling="cooperative"
          disableDefaultUI={true}
          scrollwheel={false}
          disableDoubleClickZoom={true}
          zoomControl={true}
          minZoom={4}
          maxZoom={18}
          fullscreenControl={false}
          styles={styles}
          keyboardShortcuts={false}
        >
          {isProducerProfile ? (
            producerLocations?.map((loc, idx) => (
              <AdvancedMarker key={idx} position={{ lat: loc.lat, lng: loc.lng }} anchorPoint={AdvancedMarkerAnchorPoint['BOTTOM']}>
                <Marker icon={loc.energyType ? energyToIconName(loc.energyType) : 'electricity'} />
              </AdvancedMarker>
            ))
          ) : (
            <>
              {producerLocation && (
                <AdvancedMarker
                  key="producer"
                  position={{ lat: producerLocation.lat, lng: producerLocation.lng }}
                  anchorPoint={AdvancedMarkerAnchorPoint['BOTTOM']}
                >
                  <Marker icon={producerEnergyType ? energyToIconName(producerEnergyType) : 'electricity'} />
                </AdvancedMarker>
              )}
              {userLocation && (
                <AdvancedMarker
                  key="user"
                  position={{ lat: userLocation.lat, lng: userLocation.lng }}
                  anchorPoint={AdvancedMarkerAnchorPoint['BOTTOM']}
                >
                  <Marker icon="home" />
                </AdvancedMarker>
              )}
            </>
          )}
        </Map>
      </APIProvider>
    </Suspense>
  )
}

export default ProducerMap
